import {
  Button,
  ButtonGroup,
  Center,
  Heading,
  Image,
  Modal,
  ModalBody,
  chakra,
  ModalCloseButton,
  Stack,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  Spacer,
  HStack,
  useToast,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import ModalEspecialista from '../images/ModalEspecialista.svg';
import { api } from 'api/api';
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
function ModalAvisoEspecialidade(props) {
  const disclosure = props.disclosure;

  const putLembreteEspecialista = async () => {
    api(`${ENDPOINT}/clients/putLembreteEspecialista`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ objeto: props.dados }),
    });
  };

  useEffect(() => {
    //let timeout;
    const fetchData = async () => {
      await putLembreteEspecialista();
      /*timeout = setTimeout(() => {
        disclosure.onClose();
      }, 5000); */
    };

    fetchData();
  }, [disclosure.isOpen]);

  return (
    <>
      <Modal isOpen={disclosure.isOpen} isCentered>
        <ModalOverlay />
        <ModalContent maxW="95%" h="auto" borderRadius="0.8em">
          <ModalBody>
            <VStack mb={2}>
              <Image src={ModalEspecialista} mt={4} w={'60%'} />
              <Text color={'#5AB2AE'} fontWeight={'bold'} fontSize={'1.5em'} lineHeight={'1.2em'} textAlign={'center'}>
                Fique tranquilo,
                <br />
                nós avisaremos você!
              </Text>
              <Text color={'#616161'} textAlign={'center'} fontSize={'17px'} letterSpacing={'-0.05em'}>
                Infelizmente, não há horários disponíveis para esta especialidade, mas assim que a agenda for aberta, você receberá uma notificação no
                WhatsApp. 
              </Text>
              {/* Removido Spacer para evitar espaço extra ao final do modal */}
              <Button
                w={'80%'}
                bg={'#5AB2AE'}
                color={'#FFFFFF'}
                borderRadius={'0.8em'}
                onClick={() => {
                  disclosure.onClose();
                }}
              >
                Entendi
              </Button>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ModalAvisoEspecialidade;
